import { Snowflake, Sun } from "lucide-react";

const ITEMS = [
  "5 años de experiencia",
  "2 años de garantía en la instalación",
  "3 años de garantía en la máquina",
  "Fundada en 2021",
  "Sistemas 1x1 · Multi-Split · Conductos",
  "Instalación certificada",
];

export const Marquee = () => (
  <div
    data-testid="marquee-ribbon"
    className="overflow-hidden border-y border-slate-200 bg-white py-5"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item, i) => (
            <span
              key={`${copy}-${i}`}
              className="mx-8 flex items-center gap-3 whitespace-nowrap font-display text-sm font-medium uppercase tracking-[0.18em] text-slate-500"
            >
              {i % 2 === 0 ? (
                <Snowflake className="h-4 w-4 text-ocean-500" />
              ) : (
                <Sun className="h-4 w-4 text-ember" />
              )}
              {item}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
